import { getError } from "@/utils/helpers";
import MessageService from "@/services/MessageService";

export const namespaced = true;

export const state = {
  userMessages: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_USERMESSAGE(state, userMessages) {
    state.userMessages = userMessages;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getUserMessages({ commit }) {
    commit("SET_LOADING", true);

    MessageService.getMessageUser()
      .then((response) => {
        commit("SET_USERMESSAGE", response.data.data);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      })
      .finally(() => {
        commit("SET_LOADING", false);
      });
  },
};
export const getters = {
  userMessages: (state) => {
    return state.userMessages;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
